export interface PaginationMeta {
  readonly page: number;
  readonly pageSize: number;
  readonly totalItems: number;
  readonly totalPages: number;
}

export interface PaginatedResponse<T> {
  readonly data: T[];
  readonly meta: PaginationMeta;
}

export interface PaginationParams {
  page?: number;
  pageSize?: number;
}

export function buildPaginationQuery(params?: PaginationParams): string {
  if (!params) return '';
  const parts: string[] = [];
  if (params.page !== undefined) parts.push(`page=${params.page}`);
  if (params.pageSize !== undefined) parts.push(`pageSize=${params.pageSize}`);
  return parts.length > 0 ? parts.join('&') : '';
}

export function appendPaginationQuery(basePath: string, params?: PaginationParams): string {
  const paginationQuery = buildPaginationQuery(params);
  if (!paginationQuery) return basePath;
  const separator = basePath.includes('?') ? '&' : '?';
  return `${basePath}${separator}${paginationQuery}`;
}
